import React from 'react';
import './SummaryBoxes.css';

interface StatusCount {
  label: string;
  count: number;
}

const statusCounts: StatusCount[] = [
  { label: 'New', count: 236 },
  { label: 'Closed', count: 348 },
  { label: 'Unassigned', count: 236 },
  { label: 'Pendin', count: 236 },
  { label: 'Individual', count: 32 },
  { label: 'Group', count: 59 },
];

const SummaryBoxes: React.FC = () => {
  return (
    <div className="summary-container">
      {statusCounts.map((item, index) => (
        <div
          key={index}
          className={`summary-box summary-box-${item.label.toLowerCase()}`}
        >
          <div className="summary-content">
            <div className="summary-label">{item.label}</div>
            <div className="summary-count">{item.count}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryBoxes;